import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dividerWrapper: {
    height: 1,
    width: '100%',
    marginBottom: 16,
    marginTop: 10,
    backgroundColor: theme.app.colors.border.light,

    [theme.breakpoints.down('sm')]: {
      opacity: 0
    }
  }
}))
